<template>
  <div class="mt-4">
    <h6>Informe o Código Temporário</h6>
    <p style="opacity: 0.7">
      Digite o código de 6 dígitos gerado pelo seu aplicativo de autenticação
      para verificar sua identidade.
    </p>
    <v-otp-input
      length="6"
      ref="tokenCode"
      v-model="code"
      type="number"
      :disabled="loading"
      @keyup.enter="submitToken"
    ></v-otp-input>
    <v-alert v-if="error" type="error" class="mt-4 mb-0">
      {{ error }}
    </v-alert>
    <v-btn
      block
      class="mt-4"
      color="primary"
      :disabled="code.length < 6"
      @click="submitToken"
      :loading="loading"
    >
      Verificar
    </v-btn>
  </div>
</template>

<script>
import AUTH from "@/services/auth";
import { mapActions } from "vuex";

export default {
  data: () => ({
    loading: false,
    error: null,
    code: "",
  }),
  methods: {
    ...mapActions("auth", ["setLogin"]),

    async submitToken(auto = false) {
      this.loading = true;
      this.error = null;
      try {
        const response = await AUTH.twoFAVerify(this.token, {
          type: "TOTP",
          data: { token: this.code },
        });
        this.setLogin(response);
        this.$emit("success");
      } catch (error) {
        if (!auto) this.code = "";
        this.loading = false;
        this.error = error.message;
        this.$nextTick(() => {
          this.$refs.tokenCode.focus();
        });
      }
    },
  },
  watch: {
    code(value) {
      if (value.length === 6) {
        this.submitToken(true);
      }
    },
  },
  mounted() {
    this.$refs.tokenCode.focus();
  },
  props: {
    token: {
      type: String,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>
</style>